import '../LandingPage.css';
import { FaPhone, FaEnvelope, FaFacebookF, FaArrowRight } from 'react-icons/fa';

const contactItems = [
  {
    icon: FaPhone,
    label: 'Call us',
    value: '+44 7935 501 848',
    href: 'tel:+447935501848',
  },
  {
    icon: FaEnvelope,
    label: 'Email us',
    value: 'emil.filip@efsoft.co.uk',
    href: 'mailto:emil.filip@efsoft.co.uk',
  },
  {
    icon: FaFacebookF,
    label: 'Social',
    value: 'Follow us on Facebook',
    href: 'https://www.facebook.com/profile.php?id=61572979287197',
    external: true,
  },
];

function ContactSection() {
  return (
    <section id="contact" className="contact-section section">
      <div className="section-content">
        <div className="contact-panel reveal">
          <div className="contact-intro">
            <span className="section-eyebrow section-eyebrow--light">
              Get in touch
            </span>
            <h2 className="section-title contact-title">
              Let&apos;s build something great together
            </h2>
            <p className="contact-lead">
              Have a project in mind or just want to talk software? We&apos;d
              love to hear from you.
            </p>
          </div>

          <div className="contact-info">
            {contactItems.map((item) => {
              const Icon = item.icon;
              return (
                <a
                  key={item.value}
                  href={item.href}
                  className="contact-link"
                  {...(item.external
                    ? { target: '_blank', rel: 'noopener noreferrer' }
                    : {})}
                >
                  <span className="contact-link-icon">
                    <Icon />
                  </span>
                  <span className="contact-link-body">
                    <span className="contact-link-label">{item.label}</span>
                    <span className="contact-link-value">{item.value}</span>
                  </span>
                  <FaArrowRight className="contact-link-arrow" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
